import {createFeatureSelector, createSelector} from '@ngrx/store';
import {DbStoreState} from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getZoneState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.websiteZone);

export const getVPZoneCreatedResponse = createSelector(
  getZoneState,
  (zoneState) => zoneState.clientInstanceData
);

// Selector to get loading state from zoneState
export const getZoneLoading = createSelector(
  getZoneState,
  (zoneState) => zoneState.loading
);

// Selector to get error state from zoneState
export const getZoneError = createSelector(
  getZoneState,
  (zoneState) => zoneState.error
);
